import Head from 'next/head';
import { Styleguide } from '../utils/s3';
import { getFontsPreconnectOrigin, resolveFontFaceCss } from '../utils/fonts';

interface DynamicFontsProps {
  styleguide: Styleguide | null;
}

/**
 * Fontes do styleguide no Pages Router, via `next/head`.
 *
 * No App Router quem injeta o `@font-face` é o `StyleguideStyles` (`includeFontFace`),
 * porque `next/head` não funciona lá. A geração do CSS é compartilhada em `utils/fonts`.
 */
export function DynamicFonts({ styleguide }: DynamicFontsProps) {
  const fontFaceCss = resolveFontFaceCss(styleguide);

  if (!fontFaceCss) return null;

  const preconnectUrl = getFontsPreconnectOrigin();

  return (
    <Head>
      {preconnectUrl && (
        <link rel="preconnect" href={preconnectUrl} crossOrigin="anonymous" />
      )}
      <style dangerouslySetInnerHTML={{ __html: fontFaceCss }} />
    </Head>
  );
}
